import { getZonedDate } from '@/utils/dayjs';
import type { UserInfo } from '@/types/userInfo';

/**
 * トライアル帯（SignupTrialBanner）を表示する条件と一致させる
 */
export function shouldShowSignupTrialBanner(userInfo: UserInfo | null | undefined): boolean {
    return userInfo?.signupTrialActive === true && Boolean(userInfo?.signupTrialEndsAt);
}

/**
 * トライアル帯の高さに合わせた sticky 用 top（PrivateLayout のスペーサー h-16 と一致）
 */
export const SIGNUP_TRIAL_BANNER_STICKY_TOP_CLASS = 'top-16';

/**
 * ユーザーTZの暦日ベースで、トライアル終了日までの残り日数（当日含めず端数切り捨て相当）
 */
export function getSignupTrialCalendarDaysRemaining(endsAtIso: string, timeZone?: string): number {
    const tz = timeZone?.trim() || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const end = getZonedDate(tz, endsAtIso).startOf('day');
    const today = getZonedDate(tz).startOf('day');
    return Math.max(0, end.diff(today, 'day'));
}
